import { axios } from "@/lib/axios";
import { IAPIGetServiceCategories, IAPIGetSubscriptions } from "../../types";

export const getAllSubscriptions = ({
  term,
  limit,
  page,
}: {
  term?: string;
  limit?: number;
  page?: number;
} = {}): Promise<IAPIGetSubscriptions> => {
  return axios.get("/payment-s/api/v1/purchases", {
    params: {
      fields: ["email", "name", "phone", "customerId"],
      term,
      limit,
      page,
    },
  });
};

export const getServiceCategories = (): Promise<IAPIGetServiceCategories> => {
  return axios.get("/payment-s/bo/api/v1/service-categories");
};
